import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/net-present-value-annuity-calculator',
  component: () => import('../../routes/NetPresentValueAnnuity.svelte'),
  card: {
    id: 'net-present-value-annuity-calculator',
    title: 'NPV of Annuity Calculator',
    description: 'Calculate the present value of a series of equal payments. Compare investment offers, structured settlements, and loan terms.',
    icon: 'account_balance',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/net-present-value-annuity-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'NPV of Annuity Calculator – Present Value of Equal Payments',
    description: 'Free NPV of annuity calculator. Calculate the present value of a series of equal payments with any discount rate and compounding frequency. Compare investment offers accurately.',
  },
};

export default meta;